import React from 'react';
import { usePermissions } from '../../hooks/usePermissions';
import NotFoundPage from './NotFoundPage';

interface LeaderboardProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * Route wrapper that checks for leaderboard permission.
 * Shows NotFoundPage if user doesn't have permission (Pro tier only).
 */
const LeaderboardProtectedRoute: React.FC<LeaderboardProtectedRouteProps> = ({ children }) => {
  const { hasFeature, isLoading } = usePermissions();
  const hasLeaderboardAccess = hasFeature('leaderboard');

  // Show loading state while checking permissions
  if (isLoading) {
    return <div className="flex items-center justify-center min-h-screen">Loading...</div>;
  }

  // Show NotFoundPage if user doesn't have leaderboard access
  if (!hasLeaderboardAccess) {
    return <NotFoundPage />;
  }

  return <>{children}</>;
};

export default LeaderboardProtectedRoute;
